import { createSlice, AnyAction } from '@reduxjs/toolkit'
import type { genericModuleConfigurationState } from './types'
import { ccsApi } from '../../api/ccs/react'
import { get } from 'lodash'

const initialState: genericModuleConfigurationState = {
  genericModuleConfiguration: {
    schema: undefined,
    defaultData: {},
    data: {},
    apiData: {},
  },
}

export const name = 'genericModuleConfiguration'

export const genericModuleConfigurationSlice = createSlice({
  name,
  initialState,
  reducers: {
    clearGenericConfiguraionModuleData: (state: genericModuleConfigurationState) => {
      state.genericModuleConfiguration = { ...state.genericModuleConfiguration, data: {}, apiData: {} }
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      ccsApi.endpoints.genericModule.matchFulfilled,
      (state: genericModuleConfigurationState, action: AnyAction) => {
        const { payload: data } = action
        // creating default data

        const jsonSchemaProperties = get(data, 'module_configurations.properties') as { [k: string]: any }

        let defaultValues = {} as { [k: string]: any }
        if (jsonSchemaProperties) {
          Object.keys(jsonSchemaProperties).forEach((field) => {
            defaultValues[field] = get(jsonSchemaProperties[field], 'default')
          })
        }

        // If any of the property has not been set properly, fallback to RJSF default values.
        for (const value of Object.values(defaultValues)) {
          if (typeof value === 'undefined' || value === null || (typeof value === 'number' && isNaN(value))) {
            defaultValues = {}
            break
          }
        }

        state.genericModuleConfiguration = {
          ...state.genericModuleConfiguration,
          schema: data,
          defaultData: defaultValues,
        }
      },
    )
    builder.addMatcher(ccsApi.endpoints.genericModuleConfiguration.matchFulfilled, (state, action: AnyAction) => {
      const { payload: data } = action

      // preserves any default values while also adding in fetched values
      const moduleName = Object.keys(data).filter((key) => key !== 'id')[0]

      state.genericModuleConfiguration = {
        ...state.genericModuleConfiguration,
        data: {
          ...state.genericModuleConfiguration.defaultData,
          ...data[moduleName],
        },
        apiData: data[moduleName],
      }
    })
  },
})

export const { clearGenericConfiguraionModuleData } = genericModuleConfigurationSlice.actions

export default genericModuleConfigurationSlice.reducer
